import request from '../_helpers/request';

export const downloadCenterService ={
    getDownloadCenter
}

function getDownloadCenter(query){
    return request({
        url: "EMPBackend/GetDownloadCenterFile",
        method:"post",
        params:query
      })
}

/*
function GetInquiryByAccount(UniqueCode) {
    var url = "InquiryForm/GetInquiryByAccount";
    var params = {"UniqueCode":UniqueCode, "action": {
        "LangId": localStorage.getItem("currentLangId")
        , "IP": window.location.host
        , "URL": window.location.href
        , "Referral": document.referrer
        , "BAgent": window.navigator.userAgent

    }};

    return request.post(url, params)
        .then(res => {
            if (res.data) {
                return res.data;
            } else {
                return error;
            }
        })

} */